import moment from 'moment';
import React from 'react'
import { convertFromPesewasToCedis } from '../../../utils';
import { Wallet } from 'iconoir-react';

const RefundCreditTable = ({ credit }) => {
  return (
    <div className='card p-0 overflow-hidden'>
      <table className="table-modern">
        <thead>
          <tr>
            <th>User</th>
            <th>Amount Added</th>
            <th>Before Refund</th>
            <th>After Refund</th>
            <th>Description</th>
            <th>Issued On</th>
          </tr>
        </thead>
        <tbody>
          {credit && credit.length > 0 ?
            credit.map((item, index) => {
              const transaction = item.credit_transaction || {};
              const user = transaction.user || {};
              return (
                <tr key={item.id || index}>
                  <td>
                    {user ? (
                      <div className="flex items-center gap-3">
                        <img
                          className="w-10 h-10 rounded-xl object-cover ring-2 ring-surface-100"
                          src={user.profile_pic}
                          alt=""
                          loading="lazy"
                        />
                        <div>
                          <p className="font-semibold text-surface-800">
                            {user.surname} {user.other_names}
                          </p>
                          <p className="text-xs text-surface-400 capitalize">
                            {user.role}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <span className='text-surface-400 italic'>N/A</span>
                    )}
                  </td>
                  <td>
                    <span className='font-semibold text-emerald-600'>
                      +GH₵ {convertFromPesewasToCedis(transaction.credit_amount_added).toFixed(2)}
                    </span>
                  </td>
                  <td className='text-surface-600'>
                    GH₵ {convertFromPesewasToCedis(transaction.previous_credit_amount).toFixed(2)}
                  </td>
                  <td className='font-semibold text-surface-800'>
                    GH₵ {convertFromPesewasToCedis(transaction.current_credit_amount).toFixed(2)}
                  </td>
                  <td>
                    <p className='max-w-[200px] truncate text-surface-500' title={transaction.description}>
                      {transaction.description}
                    </p>
                  </td>
                  <td className='text-surface-500'>
                    {moment(transaction.createdAt).format('MMM D, YYYY')}
                  </td>
                </tr>
              )
            }) :
            <tr>
              <td colSpan={6} className="text-center py-12">
                <div className='flex flex-col items-center gap-3'>
                  <div className='w-16 h-16 rounded-2xl bg-surface-100 flex items-center justify-center'>
                    <Wallet strokeWidth={1.5} className='w-8 h-8 text-surface-400' />
                  </div>
                  <div>
                    <p className='font-medium text-surface-600'>No credit refunds</p>
                    <p className='text-sm text-surface-400'>No credit refunds available</p>
                  </div>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  )
}

export default RefundCreditTable
